import { Fragment } from "react";
import { useTranslation } from "react-i18next";

import { CustomDetailsPage } from "components/DetailsPage/DetailsPage";
import ContentLayout from "components/layouts/ContentLayout";

import MappingBlueprintScheme from "./MappingBlueprintScheme";
import useBlueprintDetails from "./useBlueprintDetails";

const BlueprintDetails = () => {
  const { t } = useTranslation();
  const { blueprintData, setBlueprintData, createSignalMapping } =
    useBlueprintDetails();
  const fields = [
    {
      value: blueprintData?.name,
      label: "Name",
      type: "InfoText",
      show: true,
    },
    {
      value:
        blueprintData?.company?.display_name || blueprintData?.company?.name,
      id: blueprintData?.company_id,
      label: "Company",
      type: "Link",
      route: "companies",
      show: true,
    },
    {
      value: blueprintData?.number_of_rows,
      label: "Number of rows",
      type: "InfoText",
      show: true,
    },
    {
      value: blueprintData?.number_of_columns,
      label: "Number of columns",
      type: "InfoText",
      show: true,
    },
    {
      type: "CustomComponent",
      value: (
        <Fragment>
          <h1
            style={{
              margin: "auto",
              width: "50%",
              padding: "10px",
              textAlign: "center",
            }}
          >
            {t("Scheme")}
          </h1>
          <MappingBlueprintScheme />
        </Fragment>
      ),
      label: "",
      show: true,
    },
  ];

  return (
    <ContentLayout
      title={`${t("Blueprints")} > ${blueprintData?.name ?? ""}`}
      filters={false}
    >
      <CustomDetailsPage
        data={blueprintData}
        setData={setBlueprintData}
        resource={"blueprint"}
        call={"machine-blueprints"}
        fields={fields}
        //remove
        isEditable={false}
      />
    </ContentLayout>
  );
};

export default BlueprintDetails;
